<template>
  <div class="ratings" ref="ratings">
    <div class="ratings-content">
      <div class="overview">
        <div class="overview-left">
          <div class="score">{{seller.score}}</div>
          <div class="text">综合评分</div>
          <div class="ratings-ratio">高于周边商家{{seller.rankRate}}%</div>
        </div>
        <div class="overview-right">
          <div class="item">
            <span class="item-name">服务态度</span>
            <stars :size="36" :score="seller.serviceScore"></stars>
            <span class="score">{{seller.serviceScore}}</span>
          </div>
          <div class="item">
            <span class="item-name">商品评价</span>
            <stars :size="36" :score="seller.foodScore"></stars>
            <span class="score">{{seller.foodScore}}</span>
          </div>
          <div class="item">
            <span class="item-name">送达时间</span>
            <span class="delivery-time">{{seller.deliveryTime}}分钟</span>
          </div>
        </div>
      </div>
      <split></split>
      <div class="ratings-wrap">
        <ratingselect @select="selectRatings" @toggle="toggleContent" :ratings="ratings" :select-type="selectType"
                      :only-content="onlyContent"></ratingselect>
        <ul class="ratings-list">
          <li class="list-item" v-for="item in ratings" v-show="needShow(item.rateType,item.text)">
            <img :src="item.avatar" class="avatar">
            <div class="content">
              <span class="time">{{item.rateTime | formatTime}}</span>
              <span class="username">{{item.username}}</span>
              <div class="star-wrap">
                <stars size="24" :score="item.score"></stars>
                <span class="delivery-time">{{item.deliveryTime}}分钟送达</span>
              </div>
              <p class="text">{{item.text}}</p>
              <div class="recommend-wrap">
                <span class="icon"
                      :class="{'icon-thumb_up':item.rateType === 0,'icon-thumb_down':item.rateType===1}"></span>
                <span v-for="recommend in item.recommend" class="recommend">{{recommend}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {localdata} from 'common/js/data.js';
  import {formatDate} from 'common/js/date.js';
  import BScroll from 'better-scroll';
  import stars from 'components/stars/stars';
  import split from 'components/split/split';
  import ratingselect from 'components/ratingselect/ratingselect';
  /* eslint-disable no-unused-vars */
  const POSITIVE = 0;
  /* eslint-disable no-unused-vars */
  const NEGATIVE = 1;
  /* eslint-disable no-unused-vars */
  const ALL = 2;
  export default{
    props: {
      seller: {
        type: Object
      }
    },
    data() {
      return {
        ratings: localdata.ratings,
        selectType: ALL,
        onlyContent: false
      };
    },
    components: {
      stars,
      split,
      ratingselect
    },
    watch: {
      'ratings'() {
        this.$nextTick(() => {
          this._initScroll();
        });
      }
    },
    mounted() {
      this.$nextTick(() => {
        this._initScroll();
      });
    },
    methods: {
      _initScroll() {
        if (!this.ratingScroll) {
          this.ratingScroll = new BScroll(this.$refs.ratings, {
            click: true
          });
        } else {
          this.ratingScroll.refresh();
        }
      },
      selectRatings(type) {
        this.selectType = type;
        this.$nextTick(() => {
          this.ratingScroll.refresh();
        });
      },
      toggleContent() {
        this.onlyContent = !this.onlyContent;
        this.$nextTick(() => {
          this.ratingScroll.refresh();
        });
      },
      needShow(type, text) {
        if (!text && this.onlyContent === true) {
          return false;
        }
        if (this.selectType === ALL) {
          return true;
        }
        return this.selectType === type;
      }
    },
    filters: {
      formatTime(time) {
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm');
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "../../common/stylus/mixin.styl";
  .ratings
    position:fixed
    z-index:30
    top:174px
    left:0
    right:0
    bottom:0
    overflow:hidden
    .ratings-content
      .overview
        display:flex
        padding:18px 0
        .overview-left
          flex:0 0 137px
          width:137px
          text-align:center
          border-right:1px solid rgba(7, 17, 27, 0.1)
          .score
            margin-bottom:6px
            font-size:24px
            line-height:28px
            color:rgb(255, 153, 0)
          .text
            margin-bottom:8px
            font-size:12px
            line-height:12px
            color:rgb(7, 17, 27)
          .ratings-ratio
            font-size:10px
            line-height:10px
            color:rgb(147, 153, 159)
        .overview-right
          margin:0 24px
          .item + .item
            margin-top:8px
          .item
            display:flex
            .item-name
              margin-right:12px
              font-size:12px
              line-height:18px
              color:rgb(7, 17, 27)
              vertical-align:top
            .score
              margin-left:12px
              font-size:12px
              line-height:18px
              color:rgb(255, 153, 0)
              vertical-align:top
            .delivery-time
              font-size:12px
              line-height:18px
              color:rgb(147, 153, 159)
      @media only screen and (max-width:320px)
        .overview
          padding:12px 0
          .overview-left
            flex:0 0 120px
            width:120px
          .overview-right
            margin:0 10px
            .item
              .item-name
                margin-right:6px
              .score
                margin-left:6px
      .ratings-wrap
        padding:18px 0
        .ratings-list
          padding:0 18px
          .list-item
            display:flex
            padding:18px 0
            border-1px(rgba(7, 17, 27, 0.1))
            .avatar
              margin-right:12px
              width:28px
              height:28px
              border-radius:50%
            .content
              flex:1
              display:flex
              flex-direction:column
              position:relative
              .username
                font-size:10px
                line-height:12px
                color:rgb(7, 17, 27)
              .star-wrap
                display:flex
                margin-top:4px
                .delivery-time
                  margin-left:6px
                  font-size:10px
                  line-height:12px
                  color:rgb(147, 153, 159)
              .text
                margin:6px 0 8px
                font-size:12px
                line-height:18px
                color:rgb(7, 17, 27)
                letter-spacing:2px
              .recommend-wrap
                .icon
                  margin-right:8px
                  font-size:12px
                  line-height:16px
                  vertical-align:top
                  &.icon-thumb_up
                    color:rgb(0, 160, 220)
                  &.icon-thumb_down
                    color:rgb(183, 187, 191)
                .recommend
                  display:inline-block
                  margin-bottom:4px
                  margin-right:8px
                  padding:0 6px
                  font-size:9px
                  line-height:16px
                  color:rgb(147, 153, 159)
                  vertical-align:top
                  border:1px solid rgba(7, 17, 27, 0.1)
                  background-color:#fff
                  border-radius:2px
              .time
                position:absolute
                right:0
                top:0
                font-size:10px
                line-height:12px
                color:rgb(147, 153, 159)
</style>



// WEBPACK FOOTER //
// ratings.vue?88810804